<template>
  <div>
    <h2>Workout 💪</h2>
    <h3>{{ today }}</h3>
    <div class="workout">
      <div class="workout-row">
        <div class="station">&nbsp;</div>
        <div class="sets">Sets</div>
        <div class="weight">KG</div>
        <div class="rep">Whg</div>
        <div class="actions">&nbsp;</div>
      </div>
      <workout-row
        v-for="station in stations"
        :station="station"
        :key="station.id"
      ></workout-row>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import WorkoutRow from "../components/WorkoutRow";
export default {
  name: "Workout",
  components: { WorkoutRow },
  data() {
    return {
      today: this.formatToday()
    };
  },
  created() {},
  computed: {
    stations() {
      return this.$storage.getStations();
    },
    latestWorkout(stationId) {
      return this.$storage.getLatestWorkout(stationId);
    }
  },
  methods: {
    formatToday() {
      return DateTime.local()
        .setLocale("de")
        .toFormat("d. MMMM yyyy");
    }
  }
};
</script>

<style lang="scss">
.workout-row input {
  width: 100%;
  margin: 0;
  padding: 0;
}
.workout-row:first-child {
  & div {
    font-weight: bold;
  }
}
.workout-row {
  display: grid;
  grid-template-columns: 50px 50px 60px 60px 1fr;
  padding: 5px 0;
  border-bottom: 1px solid #999999;
  align-items: center;
}
.cell {
  padding: 0 5px;
}
</style>
